import { defineMessages } from 'react-intl';

export const messages: {
	allBordersLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	backgroundColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	backgroundTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	borderColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	borderPosition: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	bottomBorderLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cornerRadius: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	noBorderLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	backgroundTitle: {
		id: 'company-hub.links-menu-extension.background.title',
		defaultMessage: 'Background',
		description:
			'Bolded heading text shown at the top of the background configuration section in the links menu extension styles tab config panel.',
	},
	backgroundColor: {
		id: 'company-hub.links-menu-extension.background.color',
		defaultMessage: 'Background color',
		description: 'Text labeling a customization option for background color',
	},
	borderColor: {
		id: 'company-hub.links-menu-extension.border.color',
		defaultMessage: 'Border color',
		description: 'Text labeling a customization option for border colors',
	},
	borderPosition: {
		id: 'company-hub.links-menu-extension.border.position',
		defaultMessage: 'Border position',
		description: 'Text labeling a customization option for border positions',
	},
	noBorderLabel: {
		id: 'company-hub.links-menu-extension.no.border.label-text',
		defaultMessage: 'None',
		description:
			'Tooltip and label text for a button with an icon representing an option to style with no borders',
	},
	allBordersLabel: {
		id: 'company-hub.links-menu-extension.all.borders.label-text',
		defaultMessage: 'All sides',
		description:
			'Tooltip and label text for a button with an icon representing an option to style with borders on all sides',
	},
	bottomBorderLabel: {
		id: 'company-hub.links-menu-extension.bottom.border.label-text',
		defaultMessage: 'Bottom border',
		description:
			'Tooltip and label text for a button with an icon representing an option to style with only a bottom border',
	},
	cornerRadius: {
		id: 'company-hub.links-menu-extension.config.corner.radius.non-final',
		defaultMessage: 'Corners',
		description: 'Text labeling a customization option for corner radius',
	},
});
